import { Ticket, TicketActivityViewModel } from '../../models';
import { ApplicationUserViewModel } from './ApplicationUserViewModel';

export class TicketViewModel {
    model: Ticket;
    creationUser: ApplicationUserViewModel;
    lastModifier: ApplicationUserViewModel;
    assignedUser: ApplicationUserViewModel;
    completedUser: ApplicationUserViewModel;
    closedUser: ApplicationUserViewModel;
    activitiesViewModelList: TicketActivityViewModel[];
    assignableStatuses: number[];
}